import React, { useEffect } from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import Summary from "../component/User/Summary/Summary.jsx"
const SummaryPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);

  return (
  <>
  <Header/>
  <Summary/>
  <Footer/>
  </>
  )
}

export default SummaryPage